import myEmitter from '../component/my-events';
export const SET_EVALUATION_DATA = "SET_EVALUATION_DATA";
export const SET_EVALUATION_LOADING = "SET_EVALUATION_LOADING";
export const SET_CURRENT_EVALUATION = "SET_CURRENT_EVALUATION";
export const SET_EVALUATION_TAB_INDEX = "SET_EVALUATION_TAB_INDEX";
export const START_TIME= "START_TIME";
export const SET_ANSWER= "SET_ANSWER";
export const CLEAR_ANSWER= "CLEAR_ANSWER";
export const SET_ANALYSIS_DATA= "SET_ANALYSIS_DATA";


export function setCurrentEvaluation(evaluation) {
    return {type: SET_CURRENT_EVALUATION, evaluation};
}

export function setEvaluation(evaluation) {
    return {type: SET_EVALUATION_DATA, evaluation};
}

export function setAnalysisEvaluation(evaluation) {
    return {type: SET_ANALYSIS_DATA, evaluation};
}

export function startTime() {
    return {type: START_TIME};
}

export function setAnswer(index, answer, action) {
    console.log(index,answer,action,'22222')
    return {type: SET_ANSWER, index, answer}
}

export function clearAnswer(action) {
    return {type: CLEAR_ANSWER}
}

